import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { mediaQueryBreakpointSM } from '../Utils/Utils';
Swiper.use([Navigation, Pagination]);

const ACFBlockBeforeAfterPictures = (blockElem) => {

	new Swiper(blockElem.querySelector('.swiper'), {
		direction: 'horizontal',
		slidesPerView: 1,
		centeredSlides: false,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			clickable: false,

			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span><span>/</span>' + '<span class="' + totalClass + '"></span>'; }
		},

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 2,
				loop: false,
				spaceBetween: (blockElem.querySelectorAll('.swiper-slide').length > 1 ? -40 : 0),
			},
		}
	});
};

export default ACFBlockBeforeAfterPictures;